import { api } from "./api";

/** Batch-owner assignments drive who each alert is routed to. */
export const getAssignments = (unit) => api.get("/api/assignments", { params: { unit } });
export const saveAssignments = (unit, payload) =>
  api.put("/api/assignments", payload, { params: { unit } });

/** The caller's event stream: things that HAPPENED and concern them,
 * with read state. Cross-unit by design — read state belongs to the
 * person, not the selected unit. */
export const getFeed = () => api.get("/api/notifications/feed");
export const markRead = ({ ids, all = false } = {}) =>
  api.post("/api/notifications/read", all ? { all: true } : { ids });

/** The caller's alert feed — scoped to their role by the server. */
export const getNotifications = (unit, { all = false } = {}) =>
  api.get("/api/notifications", { params: { unit, all: all || undefined } });
export const dispatchNotifications = (unit) =>
  api.post("/api/notifications/dispatch", undefined, { params: { unit } });
export const getNotificationLog = (unit) =>
  api.get("/api/notifications/log", { params: { unit } });

export const getPerformance = (unit) => api.get("/api/performance", { params: { unit } });
export const simulatePerformance = (unit) =>
  api.post("/api/performance/simulate", undefined, { params: { unit } });
export const clearPerformance = (unit) =>
  api.del("/api/performance", { params: { unit } });
